<template>



  <v-card
    class="mx-auto"
    color="surface-variant"
    image="https://udo.rateit3.de/assets/img/three-slide/thumb-2.jpg"
    max-width="400"
  >

    <v-card-title
        style="color: #F57C00; "
        >
      System resource Usage
    </v-card-title>

    <v-card-subtitle
        style="color: #F57C00; "
        >
      System Info
    </v-card-subtitle>

    <v-progress-circular
      :model-value="value"
      :rotate="360"
      :size="100"
      :width="15"
      color="teal"
    >
      {{ value }}
    </v-progress-circular>


alte svn version tut auch nicht????


    <v-table>
      <tr>
        <td>MemoryUsage</td>
        <td>{{ summary.MemoryUsage }} %</td>

      </tr>
      <tr>
        <td>DiskUsage</td>
        <td>{{ summary.DiskUsage }} %</td>

       </tr>
      <tr>
        <td>CPUUsage</td>
        <td>{{ summary.CPUUsage }} %</td>

       </tr>

    </v-table>

  </v-card>


      <v-data-table
        :headers="headers"
        :items="containers"
        density="compact"
        :items-per-page=20
        fixed-header=true
        class="elevation-1 text-caption"
      >


          <template #item.memoryRaw="{ item }">
          <div>{{ parseMiB(item?.memory?.raw) }}</div>
        </template>
     </v-data-table>

    <div> containers </div>



      <v-table

        fixed-header
      >
        <thead>
          <tr>
            <th class="text-left">
              Name
            </th>
            <th class="text-left">
              memory.raw
            </th>
            <th class="text-left">
              cpu
            </th>
            <th class="text-left">
              container ID
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in resources[1]"
            :key="item.name"
          >
            <td>{{ item.name }}</td>
            <td>{{ item.memory.raw }}</td>
            <td>{{ item.cpu }}</td>
            <td>{{ item.container }}</td>
          </tr>
        </tbody>
      </v-table>


</template>


<script>
import { mapGetters} from 'vuex';
export default {
  name: 'SettingsScreen',

    data: () => ({
      item: '',
      value: 10,
      interval: {},
            headers: [
        { title: 'container name',
            fixed: true,
            key: 'name',align: 'start'},
        {
          title: 'memory.raw',
          key: 'memoryRaw',
          align: 'end',
        },
        { title: 'cpu',key: 'cpu',align: 'end'},
        { title: 'container ID',key: 'container',align: 'end'},

      ],


    }),
    watch: {
      dialog (val) {
        val || this.close()
      }
    },
    computed: {
      ...mapGetters({ resources: 'stateResources'}),
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },

        // Always an array ([]) even while loading
      resourcesSafe() {
        const r = this.resources ?? [];
        return Array.isArray(r) ? r : [];
      },

      // Summary object for the top card
      summary() {
        const s = this.resourcesSafe[0] || {};
        return {
          MemoryUsage: s?.MemoryUsage ?? 0,
          DiskUsage:  s?.DiskUsage  ?? 0,
          CPUUsage:   s?.CPUUsage   ?? 0,
        };
      },

      // Table items for containers list
      containers() {
        const list = this.resourcesSafe[1];
        return Array.isArray(list) ? list.filter(Boolean) : [];
      },

    },
    mounted: function () {
      console.log('Dispatch System Info')





//      for (let i = 0; i < this.settings.length; i++) {
//        console.log('Settings',this.settings[i])
//        this.array_allSettings.push(this.settings[i])
//      }

    },

    created: function () {
      console.log('Dispatch Resources')

      var obj = this
      this.$store.dispatch('getResources').then(response => {
            console.log("Got some data, now lets show something in this component",response,obj.resources)
                  for (let i = 0; i < this.resources.length; i++) {
                    console.log('resources',obj.resources[i])
                    //this.array_allSettings.push(this.settings[i])
                  }


        }, error => {
            console.error("Got nothing from server. Prompt user to check internet connection and try again",error)
        })

      this.interval = setInterval(() => {
        if (this.value === 100) {
          return (this.value = 0)
        }
        this.value += 10
        this.updateResources()
      }, 5000)

    },
    unmounted: function () {
      console.log('+++unmounted--- System Info')
      clearInterval(this.interval);

    },

  methods: {

         parseMiB(v) {
            if (typeof v !== 'string') return '';
            const left = v.split('MiB /')[0];
            const n = Number(left);
            return Number.isFinite(n) ? Math.round(n) + ' MiB' : v;
          },
        updateResources () {
          var obj = this
          this.$store.dispatch('getResources').then(response => {
                console.log("Got some data, now lets show something in this component",response,obj.resources)

            }, error => {
                console.error("Got nothing from server. Prompt user to check internet connection and try again",error)
            })
        },
        close () {
          this.dialog = false
//          setTimeout(() => {
//            this.editedItem = Object.assign({}, this.defaultItem)
//            this.editedIndex = -1
//          }, 300)
        },



        clearCache () {
          // make sure new API is supported
          if (!window.caches) {
              console.log('Clear Service Worker NOT SUPPORTED by browser')
              return;
          }

          caches.keys().then(function(names) {
              console.log('Clear Service Worker cache')
              for (var index = 0; index < names.length; index++) {
                  var name = names[index];
                  caches.delete(name);
              }
          });

        },



  }
}
</script>




<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


